module.exports = __webpack_public_path__ + "img/pre-defined.b39ee7c0.svg";